import i18n from '@/plugins/i18n'
import HttpService from '@/common/services/HttpService'
import localizationItemServerData from '@/common/services/serverData/localizationItemServerData'
import { type ActivityDTOV1, type ActivityDTOV1CreateOrUpdate, type Activity } from '@/common/types/activity'
import { PrefixTranslationsEnum } from '@/common/types/i18n'

const serviceRoot = '/agent-activity/api/v1/activities'

/**
 * Get activities list
 */
export const getAgentActivities = async (fetchAll?: boolean): Promise<Activity[]> => {
  const activitiesPipe = [
    HttpService.getData<Array<ActivityDTOV1>>(`${serviceRoot}${fetchAll ? '?fetchAll=true' : ''}`),
    localizationItemServerData.fetch({
      prefixes: PrefixTranslationsEnum.ACTIVITY,
    }),
  ] as const

  const [list] = await Promise.all(activitiesPipe)

  return list.map((a: ActivityDTOV1) => ({
    ...a,
    name: i18n.global.t(PrefixTranslationsEnum.ACTIVITY + `${a.id}`),
  }))
}

/**
 * Get a single activity
 */
export const getAgentActivity = (id: UUID) => {
  return HttpService.getData<ActivityDTOV1>(`${serviceRoot}/${id}`)
}

/**
 * Create an activity
 */
export const createAgentActivity = async (activity: ActivityDTOV1CreateOrUpdate) => {
  return HttpService.post(`${serviceRoot}`, activity)
}

/**
 * Update an activity
 */
export const updateAgentActivity = async (id: UUID, activity: ActivityDTOV1CreateOrUpdate) => {
  return HttpService.put(`${serviceRoot}/${id}`, activity)
}

/**
 * Handle activity activation
 */
export const handleActivityActivation = (activity: ActivityDTOV1, active: boolean) => {
  return HttpService.put(`${serviceRoot}/${activity.id}`, {
    ...activity,
    active,
  })
}

/**
 * Handle activity push auto blocked
 */
export const handleActivityPushAutoBlocked = (activity: ActivityDTOV1, pushAutoBlocked: boolean) => {
  return HttpService.put(`${serviceRoot}/${activity.id}`, {
    ...activity,
    pushAutoBlocked,
  })
}
